module.exports = __webpack_public_path__ + "img/SpecialistMembers.afff00be.jpg";